import { render, staticRenderFns } from "./chooseAttr.vue?vue&type=template&id=6e7e1e2b&"
import script from "./chooseAttr.vue?vue&type=script&lang=ts&"
export * from "./chooseAttr.vue?vue&type=script&lang=ts&"
import style0 from "./chooseAttr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports